export default __webpack_public_path__ + "3c07df179921277ac73b19df1d8c5163.svg";